import { ANIMATION, FLOATING_CTA_DELAY } from '../constants';

export default function registerFloatingCTA(element: string) {
    const elm: HTMLDivElement | null = document.querySelector(element);

    if (elm) {
        setTimeout(() => {
            elm.classList.add(ANIMATION.FADE_IN_FAST);
        }, FLOATING_CTA_DELAY);
    }
}
